(function(){
  var closeTimer=null;
  function loadImgs(mega){if(!mega)return;mega.querySelectorAll('img[data-src]').forEach(function(im){im.src=im.getAttribute('data-src');im.removeAttribute('data-src');});}
  function cancelClose(){if(closeTimer){clearTimeout(closeTimer);closeTimer=null;}}
  function scheduleClose(){cancelClose();closeTimer=setTimeout(plxClose,200);}
  function anyOpen(){return !!document.querySelector('#plx-megas .mega.active');}
  function relocate(){
    var hw=document.querySelector('.header-wrapper'); var m=document.getElementById('plx-megas');
    if(hw&&m&&m.parentNode!==hw){hw.appendChild(m);}
    if(hw){
      hw.addEventListener('mouseleave',scheduleClose);
      hw.addEventListener('mouseenter',cancelClose);
    }
    document.addEventListener('click',function(e){
      var nav=document.getElementById('plx-meganav'); var meg=document.getElementById('plx-megas');
      if(!anyOpen())return;
      if(nav&&nav.contains(e.target))return;
      if(meg&&meg.contains(e.target))return;
      plxClose();
    });
    document.addEventListener('keydown',function(e){if((e.key==='Escape'||e.key==='Esc')&&anyOpen())plxClose();});
  }
  window.plxOpen=function(k){
    cancelClose();
    var mega=document.querySelector('#plx-megas .mega[data-m="'+k+'"]');
    loadImgs(mega);
    document.querySelectorAll('#plx-megas .mega').forEach(function(g){g.classList.toggle('active',g.dataset.m===k);});
    document.querySelectorAll('#plx-meganav .plx-trig').forEach(function(t){t.classList.toggle('open',t.dataset.m===k);});
  };
  window.plxToggle=function(k,e){
    if(e&&e.preventDefault)e.preventDefault();
    var mega=document.querySelector('#plx-megas .mega[data-m="'+k+'"]');
    if(mega&&mega.classList.contains('active')){plxClose();}else{plxOpen(k);}
  };
  window.plxClose=function(){
    cancelClose();
    document.querySelectorAll('#plx-megas .mega').forEach(function(g){g.classList.remove('active');});
    document.querySelectorAll('#plx-meganav .plx-trig').forEach(function(t){t.classList.remove('open');});
  };
  window.plxSwitch=function(m,s){
    var mg=document.querySelector('#plx-megas .mega[data-m="'+m+'"]'); if(!mg)return;
    mg.querySelector('.content').dataset.sub=s;
    mg.querySelectorAll('.rt').forEach(function(b){var a=b.getAttribute('onmouseenter')||'';b.classList.toggle('active',a.indexOf("'"+s+"'")>-1);});
  };
  if(document.readyState!=='loading')relocate();else document.addEventListener('DOMContentLoaded',relocate);
})();
